import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['ProductContents'] });

const apiProductContentsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getProductContents: builder.query({
      query: ({ ean, ordering, page, psize }) => ({
        url: `/community/products/${ean}/contents/`,
        method: 'GET',
        params: {
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['ProductContents'],
    }),
    getOrganizationProductContents: builder.query({
      query: ({ opk, ean, ordering, page, psize }) => ({
        url: `/community/organizations/${opk}/products/${ean}/contents/`,
        method: 'GET',
        params: {
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['ProductContents'],
    }),
    addProductContent: builder.mutation({
      query: ({ opk, ean, payload }) => ({
        url: `/community/organizations/${opk}/products/${ean}/contents/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ProductContents'],
    }),
    putProductContent: builder.mutation({
      query: ({ opk, ean, id, payload }) => ({
        url: `/community/organizations/${opk}/products/${ean}/contents/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ProductContents'],
    }),
    patchProductContent: builder.mutation({
      query: ({ opk, ean, id, payload }) => ({
        url: `/community/organizations/${opk}/products/${ean}/contents/${id}`,
        method: 'PATCH',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ProductContents'],
    }),
    deleteProductContent: builder.mutation({
      query: ({ opk, ean, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/contents/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['ProductContents'],
    }),
  }),
});

export const { useGetProductContentsQuery, useGetOrganizationProductContentsQuery, useAddProductContentMutation, usePutProductContentMutation, usePatchProductContentMutation, useDeleteProductContentMutation } = apiProductContentsSlice;

export default apiProductContentsSlice;
